<template>
  <div class="t-center" v-if="isSubmitted">
    <p>Your enquiry has been sent. We will be in touch shortly.</p>
    <div class="button-stack">
      <router-link class="button" to="/properties">View properties</router-link>
      <router-link class="button" to="/user/favourites" v-if="likedPropertiesCount > 0">View my favourite properties</router-link>
    </div>
  </div>

  <form-base @submit.native.prevent="submit" v-else>
    <p>Please fill in the form below. We will be in touch shortly.</p>

    <form-input type="text" label="Full Name" placeholder="e.g. John Doe" v-model="name" :error="hasError('name')" />
    <form-input type="text" label="Email" placeholder="e.g. john.doe@example.com" v-model="email" :error="hasError('email')" />
    <form-input type="text" label="Phone no." placeholder="e.g. +356 123 456" v-model="phone" />
    <form-textarea label="Message" rows="6" placeholder="e.g. I am interested in this property. Please get in touch with me to discuss more details." v-model="message" />
    <form-checkbox labelName="consent" v-model="consent" :error="hasError('consent')">
      I consent to Remax storing my personal data provided for the sole purpose of responding to my enquiry and administering my request.
    </form-checkbox>
    <button type="submit" class="button" :disabled="isSubmitting">{{ sendStatus }}</button>
  </form-base>
</template>

<style scoped lang="scss">
  .form {
    max-width: 620px;
  }
</style>

<script>
  import { mapState, mapGetters } from 'vuex';
  import form from '@/mixins/form';
  import { backend } from '@/api';

  import FormBase from '@/components/FormBase';
  import FormInput from '@/components/FormInput';
  import FormTextarea from '@/components/FormTextarea';
  import FormCheckbox from '@/components/FormCheckbox';

  export default {
    name: 'EnquireForm',

    mixins: [form],

    components: {
      FormBase,
      FormInput,
      FormTextarea,
      FormCheckbox
    },

    props: {
      properties: {
        type: Array,
        required: true
      }
    },

    data: () => ({
      name: '',
      email: '',
      phone: '',
      message: '',
      consent: false,
      isSubmitting: false,
      isSubmitted: false
    }),

    computed: {
      ...mapState([
        'user'
      ]),

      ...mapGetters([
        'likedPropertiesCount'
      ]),

      sendStatus () {
        return this.isSubmitting ? 'Sending...' : 'Send';
      }
    },

    methods: {
      submit () {
        const { name, email, phone, message } = this;

        this.errors = [];

        if (!this.consent) {
          return this.errors.push({
            field: 'consent',
            message: 'You must check the consent checkbox.'
          })
        }

        this.isSubmitting = true;

        backend.properties.enquire({ name, email, phone, message, property: this.properties })
          .then(() => {
            this.isSubmitted = true;
          })
          .catch(({ response }) => {
            this.errors = response.data.messages;
          })
          .finally(() => {
            this.isSubmitting = false;
          })
      }
    },

    created () {
      if (this.user.authenticated) {
        this.name = this.user.name;
        this.email = this.user.email;
      }
    }
  };
</script>